import axios from "axios";
import { URL, getHeaders } from "./config";
export const processPayment = async (paymentData, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/processAuthorizeNetPayment`;
    try {
        // Ensure paymentData is an object (not stringified)
        const data = typeof paymentData === 'string' ? JSON.parse(paymentData) : paymentData;
        
        // Validate required fields
        if (!data.amount || !data.cardNumber || !data.expiryDate || !data.orderIds || !Array.isArray(data.orderIds) || data.orderIds.length === 0) {
            callback({ 
                status: 400, 
                message: "Missing payment information or order IDs" 
            });
            return;
        }

        const response = await axios.post(url, data, { headers: headers });
        if (response?.data) {
            callback({ status: 200, data: response.data });
        }
    } catch (error) {
        // Handle error response from backend
        const errorMessage = error?.response?.data?.message || error?.message || "Payment processing failed";
        const errorDetails = error?.response?.data?.details || null;
        callback({ 
            status: error?.response?.status || 400, 
            message: errorMessage,
            details: errorDetails
        });
    }
};
export const capturePaymentAPI = async (orderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/captureAuthorizeNetPayment`;
    try {
        const response = await axios.post(url, { orderId }, { headers: headers });
        if (response?.data) {
            callback({ status: 200, data: response.data });
        }
    } catch (error) {
        callback({ status: 400, message: error?.message || "Payment processing failed" });
    }
};
